import { ExclamationTriangleIcon, PencilIcon, TagIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { getIconByName } from '../../../utils/iconMapping';

export default function OffenceTag({
  offence,
  category = null,
  onClick,
  showEditIcon = true,
  showLevels = true,
  showCategory = true,
  variant = 'default', // 'default', 'compact', 'card'
  embedded = false,
  className = ''
}) {
  const isMultiLevel = offence.levels && offence.levels.length > 1;

  const variants = {
    default: 'p-3 rounded-lg bg-base-100 border border-base-300 hover:bg-base-200',
    compact: embedded
      ? 'px-2 py-1.5 rounded bg-base-100 border border-base-300 hover:bg-base-200'
      : 'p-2 rounded-md bg-base-100 border border-base-300 hover:bg-base-200',
    card: 'p-4 rounded-xl bg-base-100 border border-base-300 shadow-sm hover:shadow-md'
  };

  return (
    <motion.button
      onClick={onClick}
      className={`
        w-full text-left transition-all duration-200
        ${variants[variant]}
        ${className}
      `}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <div className={`flex items-start justify-between ${embedded ? 'gap-1.5' : 'gap-2'}`}>
        <div className="flex-1 min-w-0">
          <div className={`flex items-center flex-wrap ${embedded ? 'gap-1.5' : 'gap-2'}`}>
            <span className={`font-medium text-base-content truncate ${embedded ? 'text-sm' : ''}`}>
              {offence.name}
            </span>
            {showLevels && isMultiLevel && (
              <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-warning/10 text-warning border border-warning/20">
                L{offence.levels.join(',')}
              </span>
            )}
            {showCategory && category && (
              <span
                className={category.color && category.color !== '#3B82F6'
                  ? "inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border"
                  : "inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-primary/10 text-primary border border-primary/20"
                }
                style={category.color && category.color !== '#3B82F6' ? {
                  backgroundColor: `${category.color}20`,
                  color: category.color,
                  borderWidth: '1px',
                  borderColor: `${category.color}40`
                } : {}}
              >
                {category.icon
                  ? getIconByName(category.icon, "w-3 h-3")
                  : <TagIcon className="w-3 h-3" />
                }
                {category.name}
              </span>
            )}
          </div>
          {offence.description && !embedded && (
            <p className="text-sm text-base-content/60 mt-1 line-clamp-2">
              {offence.description}
            </p>
          )}
          {offence.alternateNames && offence.alternateNames.length > 0 && !embedded && (
            <div className="flex flex-wrap gap-1 mt-2">
              {offence.alternateNames.slice(0, 3).map((name, index) => (
                <span
                  key={index}
                  className="inline-block px-2 py-0.5 text-xs rounded-md bg-base-200 text-base-content/70"
                >
                  {name}
                </span>
              ))}
              {offence.alternateNames.length > 3 && (
                <span className="inline-block px-2 py-0.5 text-xs rounded-md bg-base-200 text-base-content/50">
                  +{offence.alternateNames.length - 3} more
                </span>
              )}
            </div>
          )}
        </div>
        {showEditIcon && (
          <PencilIcon className={`text-base-content/40 flex-shrink-0 ${embedded ? 'w-3.5 h-3.5 mt-0.5' : 'w-4 h-4 mt-1'}`} />
        )}
      </div>
    </motion.button>
  );
}